module.exports = __webpack_public_path__ + "static/media/close_icon.3c8689c8.svg";